module.exports = __webpack_public_path__ + "static/media/Raleway-Bold.f49f3d2d.ttf";